/**
 * Created by Abner Sui on 04/11/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { MarketdataService } from '../../tamalelibs/services/marketdata.service';
import { MarketdataActionTypes } from '../actions/marketdata.actions';


@Injectable()
export class MarketdataEffects {

    constructor(
        private _actions$: Actions,
        private _service: MarketdataService,
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(MarketdataActionTypes.INITIALIZE),
        switchMap(() => {
            return this._service.getAll().pipe(
                map(response => {
                    const result = this._service.parseResponse(response);
                    return {
                        type: MarketdataActionTypes.INITIALIZE_SUCCESS,
                        payload: result,
                    };
                })
            );
        })
    ));
}
